import * as React from "react";
import { ErrorInfo } from "react";
import { CLASSES } from "../CSSClassNames";

/** @internal */
export interface IErrorBoundaryProps {
    message: string;
    retryText: string;
    children: React.ReactNode;
}
/** @internal */
export interface IErrorBoundaryState {
    hasError: boolean;
}

/** @internal */
export class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error: Error) {
        return { hasError: true };
    }

    componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
        // error details available via the error boundary's retry UI; no unconditional console logging
    }

    retry = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className={CLASSES.FLEXLAYOUT__ERROR_BOUNDARY_CONTAINER}>
                    <div role="alert" className={CLASSES.FLEXLAYOUT__ERROR_BOUNDARY_CONTENT}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            {this.props.message}
                            {/* explicit tabindex: Safari only tabs to elements with an explicit tabindex */}
                            <p>
                                <button tabIndex={0} onClick={this.retry}>
                                    {this.props.retryText}
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
